/* ───────── GraphQL Queries & Mutations ───────── */

// Huvud-MENU_QUERY: alltid anon-tillgänglig. Till-specifika pong.*-attribut
// (addonLibrary, altGroupMeta etc.) hämtas i en SEPARAT KIOSK_ATTRS_QUERY
// som kan misslyckas utan att bryta hela kiosken. (Tidigare hade tills-fält
// här och LocoPOS krävde auth för att läsa dem → nya enheter utan login
// fick "Något gick fel" vid menyladdning.)
export const MENU_QUERY = `query($id: ID!, $menuType: MenuType!) {
  restaurant(id: $id) {
    name
    showsTipInClient
    queueTime
    paymentMethods { id name paymentProvider }
    deliveryLocations(menuType: $menuType) { id name }
    deliveryTimeSlots(menuType: $menuType) { id deadline disabled label value }
    menu { pages { id name categories { id name description products { id name ingredientsTextSv ingredientsTextEn allergens
      energyKcal fatMg saturatedFatMg carbohydratesMg sugarsMg proteinMg saltMg fiberMg
      addonRefs: attribute(key: "pong.addonRefs")
      properties(menuType: $menuType) {
        id stateId price preCampaignPrice description imageUrl isActive temporarilyDisabled vatRatePercentage
        openingHours { name productVisibility periods { open { day time } close { day time } } }
        alternativeGroups { id name forceChoice minChoices maxChoices
          alternativeItems { name isDefault addonProduct { id name properties(menuType: $menuType) { id stateId price isActive imageUrl description } } }
        }
      }
    } } } }
  }
}`

// Separat query för till-nivå pong.*-attribut. Kan misslyckas (t.ex. om
// anonym token saknar rättigheter) — kiosken kör vidare med defaults i så fall.
export const KIOSK_ATTRS_QUERY = `query($id: ID!) {
  restaurant(id: $id) {
    tills {
      id
      addonLibrary: attribute(key: "pong.addonLibrary")
      altGroupMeta: attribute(key: "pong.altGroupMeta")
      altGroupV2Enabled: attribute(key: "pong.altGroupV2Enabled")
    }
  }
}`

export const TERMS_QUERY = `{ currentTermsOfService { id url } }`

export const ACCEPT_TERMS = `mutation($id: ID!) { acceptTermsOfService(id: $id) }`

export const CREATE_ORDER_INTENT = `mutation($rid: ID!, $input: OrderIntentInput!) {
  createOrderIntent(restaurantId: $rid, input: $input) {
    id state totalAmountPayable vatAmountPayable finalizeAccessToken
  }
}`

export const CREATE_PAYMENT_INTENT = `mutation($oid: ID!, $input: PaymentIntentInput!) {
  createPaymentIntent(orderIntentId: $oid, input: $input) {
    id state finalizeAccessToken
    action { type stripeClientSecret qrCodeValue statusUrl deadline }
  }
}`

export const FINALIZE_PAYMENT = `mutation($pid: ID!, $t: String) {
  finalizePaymentIntent(paymentIntentId: $pid, accessToken: $t) { id state }
}`

export const CANCEL_PAYMENT = `mutation($pid: ID!) {
  cancelPaymentIntent(paymentIntentId: $pid) { id state }
}`

export const CANCEL_ORDER = `mutation($rid: ID!, $oid: ID!) {
  cancelOrderIntent(restaurantId: $rid, orderIntentId: $oid, input: {}) { id state }
}`

export const FINALIZE_ORDER = `mutation($oid: ID!) {
  finalizeOrderIntent(orderIntentId: $oid) {
    id receiptViewKey
    receiptPrinter { id name }
  }
}`

export const RECEIPT_QUERY = `query($oid: ID!, $vk: String!) {
  receipt(orderId: $oid, viewKey: $vk) { html }
}`

export const ME_QUERY = `{ me { id } }`

export const TILL_QUERY = `query($restaurantId: ID!, $tillId: ID!) {
  restaurant(id: $restaurantId) {
    till(id: $tillId) {
      id name showsStripeSwish showsTip preferredApiEnvironment
      paymentMethods { id name paymentProvider }
      posTerminals { id name isOnline isActive paymentProvider }
      receiptPrinterQueue { id name physicalPrinters { id name isOnline } }
      sendOrderToKitchen
      colorAccent: attribute(key: "pong.colorAccent")
      colorAccentHover: attribute(key: "pong.colorAccentHover")
      colorBg: attribute(key: "pong.colorBg")
      colorSurface: attribute(key: "pong.colorSurface")
      colorSurface2: attribute(key: "pong.colorSurface2")
      colorText: attribute(key: "pong.colorText")
      colorMuted: attribute(key: "pong.colorMuted")
      videoUrlMobile: attribute(key: "pong.videoUrlMobile")
      videoUrlDesktop: attribute(key: "pong.videoUrlDesktop")
      logoUrl: attribute(key: "pong.logoUrl")
      pageTitle: attribute(key: "pong.pageTitle")
      layoutMode: attribute(key: "pong.layoutMode")
      categoryNavStyle: attribute(key: "pong.categoryNavStyle")
      defaultProductLayout: attribute(key: "pong.defaultProductLayout")
      categoryColumns: attribute(key: "pong.categoryColumns")
      categoryOrder: attribute(key: "pong.categoryOrder")
      categoryConfigs: attribute(key: "pong.categoryConfigs")
      threeColCategories: attribute(key: "pong.threeColCategories")
      categoryIcons: attribute(key: "pong.categoryIcons")
      collapseEnabled: attribute(key: "pong.collapseEnabled")
      maxCollapsedRows: attribute(key: "pong.maxCollapsedRows")
      inactivityTimeout: attribute(key: "pong.inactivityTimeout")
      countdownDuration: attribute(key: "pong.countdownDuration")
      receiptAutoDismiss: attribute(key: "pong.receiptAutoDismiss")
      tipsEnabled: attribute(key: "pong.tipsEnabled")
      tipPercentages: attribute(key: "pong.tipPercentages")
      defaultLocale: attribute(key: "pong.defaultLocale")
      availableLocales: attribute(key: "pong.availableLocales")
      menuTypeOptions: attribute(key: "pong.menuTypeOptions")
      fillerTiles: attribute(key: "pong.fillerTiles")
      startScreenMedia: attribute(key: "pong.startScreenMedia")
      themePreset: attribute(key: "pong.themePreset")
      appName: attribute(key: "pong.appName")
      brandKey: attribute(key: "pong.brandKey")
      appIconUrl192: attribute(key: "pong.appIconUrl192")
      appIconUrl512: attribute(key: "pong.appIconUrl512")
      pwaThemeColor: attribute(key: "pong.pwaThemeColor")
      skipCategoryGrid: attribute(key: "pong.skipCategoryGrid")
      fullMenuCategoryBar: attribute(key: "pong.fullMenuCategoryBar")
      fullMenuCategoryBarAlign: attribute(key: "pong.fullMenuCategoryBarAlign")
    }
  }
}`

export const CREATE_ACCESS_TOKEN = `mutation($username: String!, $password: String!) {
  createAccessToken(username: $username, password: $password) { parseToken }
}`
